/**
 * Hardcoded content shipped in the LOHP bundle — NOT test fixtures.
 *
 * - `buildCertPrepContent(gettext)`: editorial content for sections that have no v2
 *   upstream yet. v1 also ships this hardcoded.
 *
 * The hero banner's fallback content (used when `/notices/me/` fails or returns empty)
 * now lives in `@udemy-v2/react-hero-banner`, alongside the component that consumes it.
 */
import type {CertPrepData} from './types';

// ---------- Certification Prep ----------
// TODO: remove when a v2 upstream is available.
// Titles, alt text, images, and URLs are not localized (matches v1); descriptions and the
// explore CTA text are, so they're run through the caller's `gettext` from `useI18n()`.
export const buildCertPrepContent = (gettext: (msgid: string) => string): CertPrepData => ({
    cards: [
        {
            id: 'comptia',
            title: 'CompTIA',
            description: gettext('Cloud, Networking, Cybersecurity'),
            alt: 'CompTIA certification badges including A+, Security+, Network+, Linux+, PenTest+, and IT Fundamentals certifications available on Udemy',
            url: '/browse/certification/comptia-certifications/',
            image: 'https://frontends.udemycdn.com/frontends-homepage/staticx/udemy/images/cert-prep/comptia-thumbnail.png',
        },
        {
            id: 'aws',
            title: 'AWS',
            description: gettext('Cloud, AI, Coding, Networking'),
            alt: 'Amazon Web Services (AWS) certification badges including Solutions Architect Associate and Professional, SysOps Administrator, DevOps Engineer, Security Specialty, and Data Analytics Specialty certifications',
            url: '/browse/certification/aws-certifications/',
            image: 'https://frontends.udemycdn.com/frontends-homepage/staticx/udemy/images/cert-prep/aws-thumbnail.png',
        },
        {
            id: 'pmi',
            title: 'PMI',
            description: gettext('Project & Program Management'),
            alt: 'Project Management Institute (PMI) certification badges including PMP, CAPM, PMI-ACP, PMI-PBA, PMI-RMP, and PgMP professional certifications',
            url: '/browse/certification/project-management-institute-pmi-certifications/',
            image: 'https://frontends.udemycdn.com/frontends-homepage/staticx/udemy/images/cert-prep/pmi-thumbnail.png',
        },
    ],
    exploreCTA: {
        text: gettext('Explore certifications and vouchers'),
        url: '/browse/certification/',
    },
});
